import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { DiaryPage } from '@/features/site/diary-page';

const searchSchema = z.object({
  date: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/site/diary')({
  validateSearch: searchSchema,
  component: DiaryRoute,
});

function DiaryRoute() {
  const { projectId } = Route.useParams();
  const { date } = Route.useSearch();
  return <DiaryPage projectId={projectId} date={date} />;
}
